export const DEFAULT_MARK_COLOR = "#5678c4";
export const isHexColor = (value: string): boolean =>
  /^#[0-9a-f]{6}$/i.test(value);
